import React, { Component } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Badge, Button, Card, CardBody, Col, Row } from "reactstrap";
import MapList from "../../components/Lists/MapList";
import {
  map_colums,
  map_pos_status,
  position_type,
} from "../../constants/map_fields";
//Import actions redux
import { getMap, getPositionTypes } from "../../store/actions";
import "./datatables.scss";

class MapPositions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      maplist: null,
      totalPages: 0,
    };
  }

  componentDidMount() {
    console.log(this.state.user);
    this.props.getMap(this.state.user, 100, 1);
    this.props.getPositionTypes(this.state.user);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.loadingGetMap === false &&
      prevProps.loadingGetMap === true
    ) {
      let map = this.props.map.elements;
      this.setState({ totalPages: this.props.map.totalPages });
      if (map) {
        this.prepareData(map);
      }
    }
  }
  //coment
  prepareData(map) {
    let columns = map_colums;
    let rows = [];
    map.forEach((m) => {
      m["rcs_position_status_name"] = (
        <Badge
          color={map_pos_status[m["rcs_position_status"]].color}
          className={
            "badge-soft-" +
            map_pos_status[m["rcs_position_status"]].color +
            " font-size-11"
          }
          pill
        >
          {map_pos_status[m["rcs_position_status"]].name}
        </Badge>
      );
      // Fallback al código crudo si apareciera algún tipo nuevo de RCS todavía no mapeado en
      // position_type, en vez de dejarlo en blanco.
      m["rcs_position_type_name"] = position_type[m["rcs_position_type"]] || m["rcs_position_type"];
      rows.push(m);
    });
    let data = { columns, rows };
    this.setState({ maplist: data });
  }

  updateMap(e) {
    e.preventDefault();
    this.props.getMap(this.state.user, 100, 1);
  }

  render() {
    if (!this.state.maplist) {
      return (
        <React.Fragment>
          <div>{this.props.t("Cargando...")}</div>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <Row>
              <Col className="col-12">
                <Button
                  color="primary"
                  className="btn btn-primary waves-effect waves-light buttonStatus usersButtons"
                  onClick={(e) => this.updateMap(e)}
                >
                  <i size="lg" className="mdi  mdi-refresh"></i>
                </Button>
                <Card>
                  <CardBody>
                    {/* <CardTitle>Stripped example </CardTitle>
                    <CardSubtitle className="mb-3">
                      mdbreact DataTables has most features enabled by default, so
                      all you need to do to use it with your own tables is to call
                    the construction function:{" "}
                      <code>&lt;MDBDataTable striped /&gt;</code>.
                  </CardSubtitle> */}

                    <MapList
                      maplist={this.state.maplist}
                      getMap={this.props.getMap}
                      totalPages={this.state.totalPages}
                      positionTypes={this.props.position_types}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateProps = (state) => {
  const { errorGetMap, loadingGetMap, map, successGetMap } = state.GetAllMap;
  const { position_types } = state.getPositionTypes;
  return {
    errorGetMap,
    loadingGetMap,
    map,
    successGetMap,
    position_types,
  };
};

export default withRouter(
  connect(mapStateProps, {
    getMap,
    getPositionTypes,
  })(withNamespaces()(MapPositions))
);
